import Vue from 'vue'
import authentication from './AuthenticationStore'
import fetchPaper from './FetchPaperStore'
import collection from './CollectionStore'
import saveRecord from './SaveRecordStore'
import createCollection from './CreateCollectionStore'
import shareCollection from './ShareCollectionStore'
import editPaper from './EditPaperStore'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules:{
    fetchPaper,
    authentication,
    collection,
    saveRecord,
    createCollection,
    shareCollection,
    editPaper
  },
})

export default store